/**
 * Owner: Masa Bayu
 * File: hub-pricing.ts
 * Date:Time: 2026-10-17 23:55
 * Description: Fasa 4 — peta harga penerbit daripada descriptor qxp-hub (SSOT
 *   harga server). Harga hub mengatasi tawaran demo tempatan dalam proyeksi
 *   marketplace; paparan mata wang tetap mengikut profil locale (lapisan paparan).
 */

export interface HubPriceEntry {
  readonly priceMinorUnits: number;
  readonly currency: string;
  readonly sampleMaxPage: number | null;
}

const priceMap = new Map<string, HubPriceEntry>();

/** Gantikan peta harga dengan snapshot catalog terkini (panggil sebelum overlay bump). */
export function setHubPrices(
  entries: Readonly<Record<string, HubPriceEntry>>,
): void {
  priceMap.clear();
  for (const [publicationId, entry] of Object.entries(entries)) {
    priceMap.set(publicationId, entry);
  }
}

export function getHubPrice(publicationId: string): HubPriceEntry | null {
  return priceMap.get(publicationId.trim()) ?? null;
}

/** Ujian sahaja. */
export function __clearHubPricesForTests(): void {
  priceMap.clear();
}
